'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _debugDocumentModeConstants = require('./debugDocumentModeConstants');

var _debugConstants = require('../debugConstants');

var _documentModeConstants = require('../../workspace/mobile/documentModeConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.fromJS({
    enabled: false,
    data: {}
});

// Constants

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _debugConstants.DEBUG_TOOL_TOGGLE:
            if (action.toolName !== _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME) return state;
            return state.set('enabled', action.enabled);
        case _documentModeConstants.DOCUMENT_MODE_CALCULATION:
            return state.set('data', Immutable.fromJS(action.result));
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/debugDocumentModeReducer.js
// module id = 1945
// module chunks = 0